import React from 'react'
import Policy from './components/Policy'

function PrivacyPolicy() {
		return (
			<div>
				<Policy />
				</div>
		)
}

export default PrivacyPolicy